// Zone flags
import './zone-flags';

// OpenTelemetry
import { initializeOtelCore, loadOtelExporters } from '@/otel';

initializeOtelCore();

import { createHead } from '@vueuse/head';
import { createApp, nextTick, reactive } from 'vue';
import { createI18n } from 'vue-i18n';
import { LANGUAGE, VUE_APP_GTM_TOKEN } from '@/env';
import { cruises } from '@/router';

// Load fonts
import '@fontsource/mulish/300.css';
import '@fontsource/mulish/400.css';
import '@fontsource/mulish/500.css';
import '@fontsource/mulish/600.css';
import '@fontsource/mulish/700.css';

import { userStore } from '@/modules/userStore';
import { loadThirdPartyScripts } from '@/postMountScripts';
import App from './App.vue';

const loadLocaleMessages = async (locale: string) => {
  const messages = await import(
    /* webpackChunkName: "locale-[request]" */ `./locales/${locale}.json`
  );
  return messages.default;
};

userStore.init();

const store = reactive({
  user: userStore,
});

const app = createApp(App);
const head = createHead();
const activeRouter = cruises;
const i18n = createI18n({
  locale: LANGUAGE,
  messages: {},
});

app.config.globalProperties.$store = store;
app.use(activeRouter);
app.use(i18n);
app.use(head);

Promise.all([
  loadLocaleMessages(LANGUAGE), // Fetch translations
  activeRouter.isReady(), // Wait for router to resolve the initial route
]).then(async ([messages]) => {
  i18n.global.setLocaleMessage(LANGUAGE, messages);

  app.mount('#app');

  await nextTick();
  await nextTick();

  loadOtelExporters();
  loadThirdPartyScripts(VUE_APP_GTM_TOKEN);

  import('vue-gtag').then(({ createGtag }) => {
    app.use(
      createGtag({
        tagId: VUE_APP_GTM_TOKEN,
      }),
    );
  });
});
